import React from 'react';
import './EventDistribution.css';

const EventDistribution = ({ 
    homeTeamName, 
    awayTeamName, 
    homeEvents, 
    awayEvents, 
    homePercentage, 
    awayPercentage 
}) => {
    return (
        <div className="stats-section">
            <h3 className="stats-section-title">Event Distribution</h3>
            <div className="event-distribution">
                <div 
                    className="team-percentage home" 
                    style={{ width: `${homePercentage}%` }}
                >
                    {homePercentage}%
                </div>
                <div 
                    className="team-percentage away" 
                    style={{ width: `${awayPercentage}%` }}
                >
                    {awayPercentage}%
                </div>
            </div>
            <div className="distribution-labels">
                <div className="distribution-label home">
                    {homeTeamName}: {homeEvents} events
                </div>
                <div className="distribution-label away">
                    {awayTeamName}: {awayEvents} events
                </div>
            </div>
        </div>
    );
};

export default EventDistribution;